import { combineReducers, configureStore } from '@reduxjs/toolkit';
import productReducer from './features/product';
import cartReducer from './features/cart';
import categoryReducer from './features/category';
import commonReducer from './features/common';
import userReducer from './features/user';
import uiReducer from './features/ui';
import favoritesReducer from './features/favorites';

const rootReducer = combineReducers({
  productState: productReducer,
  cartState: cartReducer,
  categoryState: categoryReducer,
  commonState: commonReducer,
  userState: userReducer,
  uiState: uiReducer,
  favoritesState: favoritesReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
